// --- 1. GLOBAL STATE ---
window.CartState = window.CartState || {
  cache: {},
  pending: {},
  timer: null,
  isInitialized: false,
  interactionDelay: 1000
};

function initProductModal() {
  const S = window.CartState; 
  
  const modalButtons = document.querySelectorAll(".product_modal_opener");
  const modal = document.querySelector(".product__modal");

  if (!modal) return;

  const shop_currency = modal.dataset.currency;
  const totalAmountNode = modal.querySelector(".modal_total");
  const productTotalItems = document.querySelector('.product_total_items');
  const removeAllBtn = modal.querySelector(".remove_all");
  const totalItemsNode = modal.querySelector('.total_items'); 
  const modalClose = modal.querySelector('.close_modal');
  const overlay_back = document.querySelector(".overlay_back");

  // --- 2. GLOBAL INITIALIZATION ---
  if (!S.isInitialized) {
    console.log("🚀 [Global] Initializing Cart State...");
    initializeCartCache();
    window.addEventListener("beforeunload", () => { flushPendingUpdates(); });
    S.isInitialized = true;
  }

  // --- 3. CORE LOGIC ---

  async function initializeCartCache() {
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();
      updateCacheFromCart(data);
    } catch (err) {
      console.error("Initial cart load failed", err);
    }
  }

  // Handle Duplicates (e.g. B2B split lines) by summing quantities
  function updateCacheFromCart(cartData) {
    S.cache = {}; 
    cartData.items.forEach(item => {
      if (S.cache[item.id]) {
        S.cache[item.id] += item.quantity;
      } else {
        S.cache[item.id] = item.quantity;
      }
    });
    refreshGlobalCounter(cartData.item_count);
  }

  function refreshGlobalCounter(serverBaseCount) {
    if (!totalItemsNode) return;
    let pendingDelta = 0;
    Object.entries(S.pending).forEach(([variantId, newQty]) => {
        const currentServerQty = S.cache[variantId] || 0;
        pendingDelta += (newQty - currentServerQty);
    });
    const finalCount = serverBaseCount + pendingDelta;
    totalItemsNode.textContent = `Cart Total: ${finalCount}`;
  }

  async function syncPendingChanges(useBeacon = false) {
    const variantIds = Object.keys(S.pending);
    if (variantIds.length === 0) return;

    const updatesPayload = { ...S.pending };
    S.pending = {}; 

    Object.entries(updatesPayload).forEach(([id, qty]) => { S.cache[id] = qty; });

    const payload = JSON.stringify({ updates: updatesPayload });

    try {
      if (useBeacon && navigator.sendBeacon) {
        const blob = new Blob([payload], { type: "application/json" });
        navigator.sendBeacon("/cart/update.js", blob);
        return;
      }

      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: payload,
        keepalive: true 
      });

      const cartData = await res.json();
      updateCacheFromCart(cartData);

      Object.entries(updatesPayload).forEach(([id, qty]) => {
        const input = document.querySelector(`input[data-variant-id="${id}"]`);
        if (input) {
            const serverQty = S.cache[id] || 0;
            if (serverQty !== qty) {
                 input.value = serverQty;
                 input.dataset.cart = serverQty;
                 toggleMaxWarning(input, serverQty, Number(input.max));
                 updateModalTotal(document.querySelector(".product__variants"));
            } else {
                 input.dataset.cart = qty;
            }
        }
      });
      return cartData;
    } catch (err) { console.error("Cart sync failed:", err); }
  }

  async function flushPendingUpdates() {
    clearTimeout(S.timer); 
    if (Object.keys(S.pending).length > 0) await syncPendingChanges(true); 
  }

  // --- 4. BUTTON BINDING ---
  modalButtons.forEach(btn => {
    if(btn.dataset.modalInitialized === "true") return;
    btn.dataset.modalInitialized = "true";

    btn.addEventListener("click", async function () {
      const handle = btn.dataset.handle;
      if (!handle || !modal) return;

      btn.disabled = true;
      btn.innerHTML = `<span class="spinner"></span> Loading...`;
      
      await flushPendingUpdates();
      S.pending = {}; 

      try {
        // --- HYBRID FETCH: Parallel Execution ---
        // 1. Fetch Product JSON (Respects B2B Pricing Catalog via Session)
        const productPromise = fetch(`/products/${handle}.js`).then(res => res.json());

        // 2. Fetch GraphQL (Only for Inventory Speed)
        // We assume we don't have IDs yet, so we query based on Handle in GraphQL too.
        const inventoryQuery = `
          query getInventory($handle: String!) {
            product(handle: $handle) {
              variants(first: 250) {
                nodes {
                  id
                  quantityAvailable
                }
              }
            }
          }
        `;
        const inventoryPromise = fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: { 
            "Content-Type": "application/json", 
            "X-Shopify-Storefront-Access-Token": "676130147b7d2918773770c3cdb0f89d" 
          },
          body: JSON.stringify({ query: inventoryQuery, variables: { handle: handle } })
        }).then(res => res.json());

        // Wait for BOTH (Fastest method)
        const [productData, gqlData] = await Promise.all([productPromise, inventoryPromise]);
        
        // Create Inventory Lookup Map
        const inventoryMap = {};
        if (gqlData.data && gqlData.data.product) {
            gqlData.data.product.variants.nodes.forEach(node => {
                const numericId = node.id.split("/").pop();
                inventoryMap[numericId] = node.quantityAvailable;
            });
        }

        // Setup Modal UI
        const modalImage = modal.querySelector(".product_image img");
        const modalTitle = modal.querySelector(".product__title");
        
        modalImage.src = productData.featured_image || "";
        modalTitle.textContent = productData.title;

        let oldWrapper = modal.querySelector(".product__variants");
        let variantsWrapper = oldWrapper.cloneNode(false);
        oldWrapper.parentNode.replaceChild(variantsWrapper, oldWrapper);

        variantsWrapper.innerHTML = "";
        const fragment = document.createDocumentFragment();

        // SORTING (Using the JS API Data)
        const sortedVariants = productData.variants.sort((a, b) => {
            const qtyA = inventoryMap[a.id] || 0;
            const qtyB = inventoryMap[b.id] || 0;
            const aIsAvailable = qtyA > 0;
            const bIsAvailable = qtyB > 0;
            
            if (aIsAvailable && !bIsAvailable) return -1;
            if (!aIsAvailable && bIsAvailable) return 1;
            return a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' });
        });

        sortedVariants.forEach(variant => {
          const variantId = variant.id.toString();
          const storedQty = S.cache[variantId] || 0; 
          
          // Use Map for Inventory
          const maxQty = inventoryMap[variantId] || 0; 
          
          // Use JS API for Price (This is the B2B Price in CENTS)
          // Divide by 100 to get dollar amount
          const price = variant.price / 100;
          
          let qtyinner;
          const totalAmount = price * storedQty;

          const variantBlock = document.createElement("div");
          variantBlock.className = "product_variants";
          variantBlock.dataset.variantBlock = variantId;
          
          // Image Logic (JS API uses 'featured_image' object)
          let imageHtml = `<div class="variant_img_box" style="width: 40px; height: 40px; margin-right: 10px; flex-shrink: 0;"></div>`;
          if (variant.featured_image && variant.featured_image.src) {
             imageHtml = `<div class="variant_img_box" style="width: 40px; height: 40px; margin-right: 10px; flex-shrink: 0;">
                            <img src="${variant.featured_image.src}" alt="${variant.title}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;">
                          </div>`;
          }

          const showWarningStyle = (storedQty >= maxQty && maxQty > 0) ? "display: block;" : "display: none;";

          if (maxQty <= 0) {
            qtyinner = `<span class="sold_out">Sold Out</span>`
          } else {
            qtyinner =`
              <div style="position: relative;">
                  <div style="display: flex; align-items: center;">
                    <span class="minus__icon cs__icon" data-action="minus" data-variant="${variantId}">-</span>
                    <input class="variant__qty" type="number" min="0" max="${maxQty}" step="1" value="${storedQty}" data-cart="${storedQty}" data-variant-id="${variantId}">
                    <span class="plus__icon cs__icon" data-action="plus" data-variant="${variantId}">+</span>
                  </div>
                  <div class="max_msg" style="${showWarningStyle} color: red; font-size: 10px; text-align: center; position: absolute; bottom: -20px; left: 0; right: 0;">Max limit reached</div>
              </div>`
          }

          variantBlock.innerHTML = `
            <div class="product_variant_label flex__1" style="display: flex; align-items: center;">
                ${imageHtml}
                <span>${variant.title}</span>
            </div>
            <div class="variant__quantity flex__1">
              ${qtyinner}
            </div>
            <div class="product_variant_price flex__1 text__center">${shop_currency}${price.toFixed(2)}/ea</div>
            <div class="product_variant_total flex__1 text__right" data-variant-total="${variantId}">
              ${shop_currency} ${totalAmount.toFixed(2)}
            </div>
          `;
          fragment.appendChild(variantBlock);
        });

        variantsWrapper.appendChild(fragment);
        updateModalTotal(variantsWrapper); 

        if(productTotalItems) productTotalItems.textContent = `Selected Items: ${calculateTotalQty(variantsWrapper)}`;

        // Event Listeners
        variantsWrapper.addEventListener("input", e => { clearTimeout(S.timer); handleQuantityChange(e); });
        variantsWrapper.addEventListener("click", e => { clearTimeout(S.timer); handleQuantityChange(e); });
        
        variantsWrapper.addEventListener("keydown", function(e) {
             if (e.target.classList.contains('variant__qty') && e.key === 'Enter') {
                 e.preventDefault(); 
                 const inputs = Array.from(variantsWrapper.querySelectorAll('.variant__qty'));
                 const currentIndex = inputs.indexOf(e.target);
                 if (currentIndex > -1 && currentIndex < inputs.length - 1) {
                     const nextInput = inputs[currentIndex + 1];
                     nextInput.focus();
                     nextInput.select(); 
                 }
             }
        });
    
        if(removeAllBtn) {
            removeAllBtn.onclick = (e) => {
                e.preventDefault();
                clearTimeout(S.timer);

                const qtyToRemove = calculateTotalQty(variantsWrapper);
                const inputs = variantsWrapper.querySelectorAll('.variant__qty');
                
                inputs.forEach(input => {
                    const variantId = input.dataset.variantId;
                    const originalCartQty = Number(input.dataset.cart) || 0; 
                    
                    input.value = 0; 
                    toggleMaxWarning(input, 0, Number(input.max));

                    const totalNode = variantsWrapper.querySelector(`[data-variant-total="${variantId}"]`);
                    if(totalNode) totalNode.textContent = `${shop_currency} 0.00`;
                    const plusBtn = variantsWrapper.querySelector(`.plus__icon[data-variant="${variantId}"]`);
                    if(plusBtn) plusBtn.disabled = false;
                    
                    if (originalCartQty > 0) S.pending[variantId] = 0; 
                    else delete S.pending[variantId]; 
                });

                if(totalItemsNode && qtyToRemove > 0) {
                    const currentGlobal = parseInt(totalItemsNode.textContent.replace(/\D/g, '')) || 0; 
                    totalItemsNode.textContent = `Cart Total: ${Math.max(0, currentGlobal - qtyToRemove)}`;
                }
                
                if(productTotalItems) productTotalItems.textContent = "Selected Items: 0";

                updateModalTotal(variantsWrapper); 
                S.timer = setTimeout(() => { syncPendingChanges(); }, 500); 
            };
        }

        function handleQuantityChange(e) {
          let action, variantId;
          
          if (e.type === "click") { 
            action = e.target.dataset.action; 
            variantId = e.target.dataset.variant; 
          } else if (e.type === "input" && e.target.classList.contains("variant__qty")) { 
            variantId = e.target.dataset.variantId; 
          }
          
          if (!variantId) return;

          const input = variantsWrapper.querySelector(`input[data-variant-id="${variantId}"]`);
          const totalNode = variantsWrapper.querySelector(`[data-variant-total="${variantId}"]`);
          const variantPrice = parseFloat(variantsWrapper.querySelector(`[data-variant-block="${variantId}"] .product_variant_price`).textContent.replace(shop_currency, "").replace("/ea","").trim());
          const maxQty = Number(input.max);
          
          let previousQty = S.pending[variantId];
          if (previousQty === undefined) {
              previousQty = S.cache[variantId] || 0;
          }

          let newQty = Number(input.value); 
          if (action === "plus") newQty++;
          if (action === "minus") newQty--;

          if (newQty > maxQty) newQty = maxQty;
          if (newQty < 0) newQty = 0;
          
          input.value = newQty;
          toggleMaxWarning(input, newQty, maxQty);
          
          if(totalItemsNode) {
             const delta = newQty - previousQty;
             if (delta !== 0) {
                 const currentGlobal = parseInt(totalItemsNode.textContent.replace(/\D/g, '')) || 0;
                 totalItemsNode.textContent = `Cart Total: ${currentGlobal + delta}`;
             }
          }

          if(productTotalItems) productTotalItems.textContent = `Selected Items: ${calculateTotalQty(variantsWrapper)}`;
          totalNode.textContent = `${shop_currency} ${(variantPrice * newQty).toFixed(2)}`;
        
          const originalCartQty = Number(input.dataset.cart) || 0;
          if (newQty !== originalCartQty) S.pending[variantId] = newQty;
          else delete S.pending[variantId];

          S.timer = setTimeout(() => { syncPendingChanges(); }, S.interactionDelay);
          updateModalTotal(variantsWrapper);
        }

        modal.classList.remove("closed");
        document.body.style.overflow = 'hidden';
        overlay_back.classList.remove('closed');
      } catch (err) { console.error(err); }

      btn.disabled = false;
      btn.innerHTML = "Choose Options";
    });
  });

  // --- HELPERS ---
  function toggleMaxWarning(input, qty, max) {
    const parent = input.closest('.variant__quantity') || input.parentNode.parentNode; 
    const warning = parent.querySelector('.max_msg');
    const plusBtn = parent.querySelector('.plus__icon');

    if (qty >= max && max > 0) {
        if(warning) warning.style.display = 'block';
        if(plusBtn) plusBtn.disabled = true;
        input.style.borderColor = 'red'; 
    } else {
        if(warning) warning.style.display = 'none';
        if(plusBtn) plusBtn.disabled = false;
        input.style.borderColor = ''; 
    }
  }

  function calculateTotalQty(wrapper) {
    return [...wrapper.querySelectorAll('.variant__qty')]
      .reduce((acc, input) => acc + (Number(input.value) || 0), 0);
  }

  function updateModalTotal(wrapper) {
    let sumPrice = 0;
    wrapper.querySelectorAll('.product_variants').forEach(block => {
        const variantId = block.dataset.variantBlock;
        const totalNode = block.querySelector(`[data-variant-total="${variantId}"]`);
        if(totalNode) {
            sumPrice += parseFloat(totalNode.textContent.replace(shop_currency, "").trim() || 0);
        }
    });
    if (totalAmountNode) totalAmountNode.textContent = `Total Amount: ${shop_currency} ${sumPrice.toFixed(2)}`;
  }

  modalClose.onclick = async function() { await flushPendingUpdates(); closeModalUI(); };
  overlay_back.onclick = async function() { await flushPendingUpdates(); closeModalUI(); };

  function closeModalUI() {
    modal.classList.add('closed');
    document.body.style.overflow = '';
    overlay_back.classList.add('closed');
    const variantsWrapper = modal.querySelector(".product__variants");
    if(variantsWrapper) variantsWrapper.innerHTML = "";     
  }
}

// ... Utility functions ...
function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) return resolve(el);
    const interval = 100;
    let waited = 0;
    const t = setInterval(() => {
      const found = document.querySelector(selector);
      if (found) { clearInterval(t); resolve(found); }
      waited += interval;
      if (waited >= timeout) { clearInterval(t); reject(new Error('Element not found: ' + selector)); }
    }, interval);
  });
}

function initMutationObserverForElement(selector, callback, options = { childList: true, subtree: true }) {
  waitForElement(selector).then(target => {
    const observer = new MutationObserver((mutations) => { callback(mutations, target); });
    observer.observe(target, options);
  }).catch(err => console.warn(err.message));
}

initMutationObserverForElement('#ajax-collection-wrapper', () => { initProductModal(); });
document.addEventListener('DOMContentLoaded', initProductModal);

